import React from 'react';
import { Menu, Button, Radio, Checkbox } from 'antd';
import cn from 'classnames';
import styles from './TableFilterMenu.module.scss';

const getKeys = (selectedKeys, filterMultiple, value) => {
  if (selectedKeys && filterMultiple) {
    return selectedKeys.includes(value)
      ? selectedKeys.filter((selectedKey) => selectedKey !== value)
      : [...selectedKeys, value];
  }

  return [value];
};

const TableFilterMenu = ({
  onReset,
  onConfirm,
  items,
  selectedKeys,
  setSelectedKeys,
  filterMultiple = true,
  menuClassName,
}) => {
  const handleMenuClick = ({ item }) => {
    const data = getKeys(selectedKeys, filterMultiple, item.props.value);
    setSelectedKeys(data);
  };

  return (
    <div className={styles.root}>
      <Menu
        className={cn(styles.menu, menuClassName)}
        selectedKeys={selectedKeys}
        onClick={handleMenuClick}
      >
        {items.map((item) => (
          <Menu.Item
            key={item.value}
            className={cn({
              [styles.selected]: selectedKeys?.includes(item.value),
            })}
            value={item.value}
          >
            {filterMultiple ? (
              <Checkbox
                className={styles.checkbox}
                checked={selectedKeys?.includes(item.value)}
              />
            ) : (
              <Radio
                className={styles.checkbox}
                checked={selectedKeys?.includes(item.value)}
              />
            )}
            {item.text}
          </Menu.Item>
        ))}
      </Menu>
      <div className={styles.actionsWrap}>
        <Button type="primary" onClick={onConfirm}>
          Ок
        </Button>
        <Button onClick={onReset}>Сбросить</Button>
      </div>
    </div>
  );
};

export default TableFilterMenu;
